export enum OverviewSection {
  AiSummary = "AI_SUMMARY",
  Memos = "MEMOS",
  CarePlans = "CARE_PLANS",
  Demographics = "DEMOGRAPHICS",
  Measurements = "CUSTOM_MEASUREMENTS",
  Devices = "DEVICES",
  Medications = "MEDICATIONS",
  Supplements = "SUPPLEMENTS",
  Pharmacies = "PHARMACIES",
  PatientHealth = "PATIENT_HEALTH",
  Insurance = "INSURANCE",
  Purchases = "PURCHASES",
}

export interface OverviewSectionPreference {
  section: OverviewSection;
  position: number;
  visible: boolean;
}

export interface OverviewLayoutResponse {
  sections: OverviewSectionPreference[];
}
